import { Modal } from '@ts/components/Modal';
import { Share } from '@ts/components/Share';
import { CopyButton } from '@ts/components/CopyButton';

export const init = () => {
    setHTMXListeners();
    setInteractiveElements();
    setShareSupportersModalTrigger();
    setRemoveSupporterTrigger();
}

const setHTMXListeners = () => {
    document.body.addEventListener('htmx:afterSwap', setInteractiveElements);
    document.body.addEventListener('htmx:historyRestore', setInteractiveElements);
}

const setInteractiveElements = () => {
    setCloseModalTrigger();
    setShareSupportersMessage();
    setCopyShareShopMessage();
}

const setShareSupportersModalTrigger = () => {
    const shareParticipantsModalTriggers = document.querySelectorAll('.display-share-shop-modal');
    shareParticipantsModalTriggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            createShareSupportersModal();
        });
    });
}

const createShareSupportersModal = () => {
    const shareShopModal = document.getElementById('share-shop-modal');
    const modalTitle = shareShopModal?.dataset.modalTitle;
    Modal.create('#share-shop-modal', {
        modalTitle: modalTitle ?? 'Share Your Shop',
        modalSize: 'modal-md'
    });
}

const setShareSupportersMessage = () => {
    const shareButton = document.querySelector('#share-shop-message-btn');
    if (!shareButton) return;
    
    const webshare = Share.create(shareButton, {
        text: document.querySelector('.funderworks-share-shop-message')?.textContent,
        onSuccess: (event) => handleShareSuccess(shareButton),
        onFail: (event) => handleShareFail()
    });
}

const setCopyShareShopMessage = () => {
    const copyButton = document.querySelector('#share-shop-modal #copy-shop-link-modal-btn');
    if (!copyButton) return;
    
    CopyButton.create(copyButton, {
        text: document.querySelector('.funderworks-share-shop-message')?.textContent,
        onSuccess: (event) => handleCopySuccess(copyButton),
        onFail: (event) => handleShareFail()
    });
}

const handleShareFail = () => {
    // console.log('failure');
}
const handleShareSuccess = async (btn) => {
    // console.log('success');
}

const handleCopySuccess = async (btn) => {
    const confirmShareUrl = btn.dataset.confirmShare;
    if (!confirmShareUrl) return;
    copyConfirmShare(confirmShareUrl);
}

const copyConfirmShare = async (confirmShareUrl) => {
    const response = await fetch(confirmShareUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: '{}'
    });
    
    if (!response.ok) {
        throw new Error(`Confirm share failed: ${response.status}`);
        return;
    }
}


const setCloseModalTrigger = () => {
    const closeModalButton = document.querySelector('.close-participant-share-modal');
    if (!closeModalButton) return;
    closeModalButton.addEventListener('click', (e) => {
        e.preventDefault();
        Modal.closeAllModals();
    });
}

const setRemoveSupporterTrigger = () => {
    const supportersTbody = document.querySelector('#supporters-tbody');
    if (!supportersTbody) return;

    supportersTbody.addEventListener('click', (e) => {
        const removeButton = e.target.closest('.remove-supporter');
        if (!removeButton) return;

        e.preventDefault();
        confirmRemoveSupporter(removeButton);
    });
}

const confirmRemoveSupporter = (removeButton) => {
    const { supporterName, removeSupporterUrl } = removeButton.dataset;

    Modal.createConfirmModal({
        title: 'Remove Supporter',
        message: `Are you sure you want to remove ${supporterName}? This can't be undone, but you can always add them again.`,
        confirmText: 'Remove',
        cancelText: 'Cancel',
        onConfirm: async () => removeSupporter(removeButton, removeSupporterUrl)
    });
}

const removeSupporter = async (removeButton, removeSupporterUrl) => {
    try {
        const response = await fetch(removeSupporterUrl, { method: 'DELETE' });

        if (response.ok) {
            const supportersTbody = document.querySelector('#supporters-tbody');
            const supporterRow = removeButton.closest('tr');

            if (!supportersTbody || !supporterRow) return;

            if (supportersTbody.children.length > 1) {
                supporterRow.remove();
                return;
            }

            displayNoSupportersRow(supporterRow, supportersTbody);
            removeSupportersCongrats();

            return;
        }

        Modal.createAlertModal({
            title: 'Remove Failed',
            message: 'There was a problem removing this supporter, please try again.'
        });
    } catch (error) {
        console.error('Error removing supporter:', error);
    }
}

const removeSupportersCongrats = () => {
    document.querySelector('.supporters-congrats')?.remove();
}

const displayNoSupportersRow = (supporterRow, supportersTbody) => {
    const supporterTable = supportersTbody.closest('table');
    if (!supporterTable) return;

    supporterTable?.classList.add('no-results');
    supporterRow.classList.add('is-empty');

    supporterRow.querySelectorAll('.cell-value').forEach(cellValue => cellValue.textContent = '');
    supporterRow.querySelector('.contact-info')?.remove();
    supporterRow.querySelector('.remove-supporter')?.remove();

    const supporterStatus = supporterRow.querySelector('.supporter-status');
    if (supporterStatus) {
        const emptyStatusValue = document.createElement('span');
        emptyStatusValue.classList.add('cell-value');
        supporterStatus.replaceChildren(emptyStatusValue);
    }

    const noResultsMessage = supporterTable.closest('.table-container')?.querySelector('.no-results-message');
    if (noResultsMessage) noResultsMessage.hidden = false;
}